import { Component, EventEmitter, Input, Output } from "@angular/core";
import { POEmailContact } from "../../../../core/models/orders/poEmailContact";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "jni-po-email-recipients",
  templateUrl: "./po-email-recipients.component.html",
  styleUrls: ["./po-email-recipients.component.scss"],
  imports: [TableModule, CommonModule, FormsModule],
})
export class PoEmailRecipientsComponent {
  @Input() recipientsList: POEmailContact[] = [];
  @Output() recipientsDeletedEvent = new EventEmitter<POEmailContact[]>();
  @Output() recipientsAddEvent = new EventEmitter<boolean>();
  recipientsListSelected = [];

  onDelete() {
    this.recipientsDeletedEvent.emit(this.recipientsListSelected);
    this.recipientsListSelected = [];
  }

  onAdd() {
    this.recipientsAddEvent.emit(true);
    this.recipientsListSelected = [];
  }
}
